import React from 'react';
import { MenuItem, TextField, Box } from '@mui/material';
import ChevronDownIcon from '../../icon/ChevronDownIcon';
import timeOptions from '../../../constant/time';

export interface TimePickerProps {
    value: number;
    onChange: (value: number) => void;
    disabled?: boolean;
}

const TimePicker: React.FC<TimePickerProps> = ({ value, onChange, disabled }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(Number(event.target.value));
    };
    return (
        <TextField
            select
            value={value}
            onChange={handleChange}
            disabled={disabled}
            fullWidth
            SelectProps={{
                IconComponent: () => (
                    <Box sx={{ mr: '8px', fontSize: '20px', color: (theme) => theme.palette.primary50 }}>
                        <ChevronDownIcon />
                    </Box>
                ),
                MenuProps: {
                    PaperProps: {
                        sx: {
                            maxHeight: 150,
                        },
                    },
                },
            }}
        >
            {timeOptions.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                    {item.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default TimePicker;
